import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const defaultBundleId = '028e6a97-7d39-4174-8736-270b7c1f1bd1';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  bundles: [],
  bundle: {
    bundleId: defaultBundleId,
    topics: [],
  },
  products: [],
  keywords: [],
  loading: false,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoadBundlesSuccess(state, { payload }) {
  const { bundles } = payload;
  const bundle = bundles.find(item => item.bundleId === (state.bundle.bundleId || defaultBundleId));

  return {
    ...state,
    bundles,
    bundle,
  };
}

function onLoadProductsSuccess(state, { payload }) {
  const { products } = payload;

  return {
    ...state,
    products,
    loading: false,
  };
}

function onSetFilter(state, { payload }) {
  const { keywords } = payload;

  return {
    ...state,
    keywords,
  };
}

function onSetBundle(state, { payload }) {
  const { bundle } = payload;

  return {
    ...state,
    bundle,
    keywords: [],
  };
}

function onLoadError(state) {
  return {
    ...state,
    isLoading: false,
  };
}

function onLoadProductsRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onClear(state) {
  return {
    ...state,
  };
}

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.LOAD_BUNDLES_SUCCESS]: onLoadBundlesSuccess,
  [actions.LOAD_PRODUCTS_SUCCESS]: onLoadProductsSuccess,
  [actions.LOAD_PRODUCTS_REQUEST]: onLoadProductsRequest,
  [actions.SET_FILTER]: onSetFilter,
  [actions.LOAD_ERROR]: onLoadError,
  [actions.CLEAR]: onClear,
  [actions.SET_BUNDLE]: onSetBundle,
});
